import { NgModule } from '@angular/core';
import { FlexModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '@fuse/material.module';

import { FuseSharedModule } from '@fuse/shared.module';

import { MailingDetailExternalComponent } from 'app/main/content/pages/mailing-detail-external/mailing-detail-external.component';

const routes = [
    {
        path     : 'mail-detail/:recId/:index',
        component: MailingDetailExternalComponent
    }
];

@NgModule({
    declarations: [
        MailingDetailExternalComponent
    ],
    imports     : [
        RouterModule.forChild(routes),
        MaterialModule,
        FlexModule,
        FuseSharedModule
    ]
})
export class MailingDetailExternalModule
{
}
